export var InternalTransfer;
(function (InternalTransfer) {
    InternalTransfer["withdraw"] = "WITHDRAW";
    InternalTransfer["fund"] = "FUND";
})(InternalTransfer || (InternalTransfer = {}));
